import { v4 as uuidv4 } from 'uuid';
function generateUUID() {
    return uuidv4();
}
export { generateUUID, };
//# sourceMappingURL=uuid.js.map